import { toast } from "react-toastify";
import { getAdditionalFields, getTourCategory, getVehicalCategoryList } from "../actions/indexActions";
import TermsAndCondition from "../../pages/TicketInfo/TermsAndCondition";
import RefundPolicy from "../../pages/TicketInfo/RefundPolicy";
import CancellationPolicy from "../../pages/TicketInfo/CancellationPolicy";

const initialState = {
  roles: [],
  adminUsers: [],
  VisitorTypeLists: [],
  VisitorSubTypeLists: [],
  VisitorSubSubTypeLists: [],
  cities: [],
  locations: [],
  loading: false,
  errors: {},
  categories: [],
  Zonelists: [],
  PlaceZonelists: [],
  SubZonelists: [],
  SubSubZonelists: [],
  VehicalCategoryList: [],
  VehicalsTypelists: [],
  VehicalsNumberlists: [],
  categoriesList: [],
  subCategories: [],
  subSubCategories: [],
  subCategoriesList: [],
  offerlists: [],
  bannerlists: [],
  visitorDetailOfPlace: [],
  visitorTypeofPlace: [],
  organizationLists: [],
  organizationVideoLists: [],
  PlaceLists: [],
  PricePlaceLists: [],
  visitorSubTypeListByType: [],
  visitorSubSubTypeListBySubType: [],
  stateLists: [],
  GalleryLists: [],
  HomeLists: [],
  places: [],
  MerchantLists: [],
  MerchantPortfolioLists: [],
  merchants: [],
  BlogCategoryList: [],
  blogCategories: [],
  BlogList: [],
  PartnerLists: [],
  OnlineBookingists: [],
  EventLists: [],
  TourGuideList: [],
  CheckThisOutLists: [],
  SchemeLists: [],
  SubscriberLists: [],
  TicketTypeList: [],
  TicketSubTypeList: [],
  TicketSubSubTypeList: [],
  TouristTypeList: [],
  TicketPriceList: [],
  SeoLists: [],
  questionReviewCategories: [],
  States: [],
  BookingLists: [],
  additionalFieldsList: [],
  subAdditionalFieldsList: [],
  subSubAdditionalFieldsList: [],
  bookingCategoriesList: [],
  bookingSubCategoriesList: [],
  bookingSubSubCategoriesList: [],
  visitorCategories: [],
  visitorSubCategories: [],
  visitorSubSubCategories: [],
  bookingCategories: [],
  bookingSubCategories: [],
  bookingSubSubCategories: [],
  additionalCategories: [],
  additionalSubCategories: [],
  additionalSubSubCategories: [],
  bookingTimingForm: [],
  ticketInfo: [],
  destination: [],
  destinationCount: 0,
  TourGuideListCount: 0,
  adminUserCount: 0,
  subCategoryCount: 0,
  subSubCategoryCount: 0,
  categoriesCount: 0,
  offerCount: 0,
  bannerCount: 0,
  locationsCount: 0,
  organizationCount: 0,
  organizationVideoCount: 0,
  placeCount: 0,
  galleryCount: 0,
  merchantCount: 0,
  merchantPortfolioCount: 0,
  blogCategoryCount: 0,
  blogCount: 0,
  partnerCount: 0,
  OnlineBookingistCount: 0,
  eventCount: 0,
  checkThisOutCount: 0,
  schemeCount: 0,
  subscriberCount: 0,
  seoCount: 0,
  StateCount: 0,
  bookingCount: 0,
  BookigFormDetails: [],
  ticketFormAdditionalDetails: [],
  additionalFieldDetails: [],
  BookigFormDetailsCount: 0,
  TermsAndCondition: [],
  TermsAndConditionCount: 0,
  RefundPolicy: [],
  RefundPolicyCount: 0,
  CancellationPolicy: [],
  CancellationPolicyCount: 0,
  ticketBookingForms: [],
  ticketBookingFormsCount: 0,
  editBookingForm: [],
  placeTicketTypes: [],
  placeSubTicketTypes: [],
  placeSubSubTicketTypes: [],
  zoneList: [],
  subZoneList: [],
  subSubZoneList: [],
  vehicleNumList: [],
  vehicleTypeList: [],
  vehicleCategoriesList: [],
  visitorCatList: [],
  visitorSubCatList: [],
  visitorSubSubCatList: [],
  editVisitorDetails: [],
  bookingTimings: [],
  ticketBasePrice: {},
  servicesPrice: [],
  ticketPrices: [],
  ticketsPerDay: [],
  priceFormDetails: [],
  ticketBookingFormsList: {
    data:[],
    currentPage:1,
    limit:1,
    totalPages:1,
    totalRecords:1,
  },
  statusCounts: {
    pendingCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    infoCount: 0,
  },
};


const indexReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ROLES_PENDING":
    case "GET_ADMINS_LIST_PENDING":
    case "GET_CATEGORIES_PENDING":
    case "GET_SUBCATEGORIES_PENDING":
    case "GET_SUBSUBCATEGORIES_PENDING":
    case "GET_SUBCATEGORIES_LIST_PENDING":
    case "GET_ORGANIZATIONVIDEO_LIST_PENDING":
    case "GET_ORGANIZATION_LIST_PENDING":
    case "GET_OFFERLIST_PENDING":
    case "GET_BANNERLIST_PENDING":
    case "GET_CATEGORIES_LIST_PENDING":
    case "GET_PLACE_LIST_PENDING":
    case "GET_PRICE_PLACE_LIST_PENDING":
    case "GET_STATE_LIST_PENDING":
    case "GET_GALLERY_LIST_PENDING":
    case "GET_VISITOR_DETAILS_BY_PLACE_PENDING":
    case "GET_HOME_LIST_PENDING":
    case "GET_ZONE_LIST_PENDING":
    case "GET_ZONE_LIST_BY_PLACE_PENDING":
    case "GET_ALL_BY_PLACE_PENDING":
    case "GET_SUB_ZONE_LIST_BY_ZONE_PENDING":
    case "GET_SUB_SUB_ZONE_LIST_BY_ZONE_PENDING":
    case "GET_ALL_PLACE_PENDING":
    case "GET_MERCHANT_LIST_PENDING":
    case "GET_ALL_MERCHANTS_PENDING":
    case "GET_MERCHANT_PORTFOLIO_LIST_PENDING":
    case "GET_BLOG_CATEGORY_LIST_PENDING":
    case "GET_ALL_BLOG_CATEGORY_PENDING":
    case "GET_BLOG_LIST_PENDING":
    case "GET_PARTNER_LIST_PENDING":
    case "GET_EVENT_LIST_PENDING":
    case "GET_CHECKTHISOUT_LIST_PENDING":
    case "GET_SCHEME_LIST_PENDING":
    case "GET_SUBSCRIBER_LIST_PENDING":
    case "GET_TICKET_TYPE_LIST_PENDING":
    case "GET_TICKET_SUB_TYPE_LIST_PENDING":
    case "GET_TICKET_SUB_SUB_TYPE_LIST_PENDING":
    case "GET_REVIEW_CATEGORY_LIST_PENDING":
    case "GET_SEO_LIST_PENDING":
    case "GET_STATELIST_PENDING":
    case "GET_BOOKING_LIST_PENDING":
    case "GET_CITY_PENDING":
    case "GET_LOCATIONS_PENDING":
    case "GET_TOUR_GUIDE_LIST_PENDING":
    case "GET_BOOKING_FORM_DATA_PENDING":
    case "GET_TOURIST_TYPE_LIST_PENDING":
    case "GET_TICKET_PRICE_LIST_PENDING":
    case "GET_ADDITIONAL_FIELDS_PENDING":
    case "GET_SUB_ADDITIONAL_FIELDS_PENDING":
    case "GET_SUB_SUB_ADDITIONAL_FIELDS_PENDING":
    case "GET_VEHICAL_CATEGORY_PENDING":
    case "GET_VEHICAL_TYPE_PENDING":
    case "GET_ALL_CATEGORIES_AND_VEHICAL_PENDING":
    case "GET_VEHICAL_NUMBER_PENDING":
    case "GET_VISITOR_SUB_TYPE_BY_TYPE_PENDING":
    case "GET_VISITOR_SUB_SUB_TYPE_BY_TYPE_PENDING":
    case "GET_VISITOR_CATEGORY_PENDING":
    case "GET_ALL_VISITOR_CATEGORIES_PENDING":
    case "GET_VISITOR_DETAILS_PENDING":
    case "GET_VISITOR_SUB_CATEGORY_PENDING":
    case "GET_VISITOR_SUB_SUB_CATEGORY_PENDING":
    case "GET_BOOKING_CATEGORIES_PENDING":
    case "GET_ADDITIONAL_CATEGORIES_PENDING":
    case "GET_BOOKING_TIMING_FORM_PENDING":
    case "GET_TICKET_INFO_PENDING":
    case "GET_DESTINATION_PENDING":
    case "GET_TERMS_AND_CONDITIONS_PENDING":
    case "REFUND_POLICY_PENDING":
    case "CANCELLATION_POLICY_PENDING":
    case "EDIT_BOOKING_FORM_PENDING":
    case "GET_ALL_TICKET_TYPE_PENDING":
    case "DELETE_MULTIPLE_TIMING_PENDING":
    case "GET_TICKET_PRICE_DETAILS_PENDING":
    case "GET_TICKETS_PER_DAY_PENDING":
      return { ...state, loading: true };

    case "GET_ROLES_FULFILLED":
      return { ...state, loading: false, roles: action.payload };

    case "GET_ADMINS_LIST_FULFILLED":
      return {
        ...state,
        adminUsers: action.payload,
        adminUserCount: action.adminUserCount,
      };
    case "GET_TERMS_AND_CONDITIONS_FULFILLED":
      return {
        ...state,
        loading: false,
        TermsAndCondition: action.payload.data,
        TermsAndConditionCount: action.TermsAndConditionCount,
      };
    case "GET_REFUND_POLICY_FULFILLED":
      return {
        ...state,
        loading: false,
        RefundPolicy: action.payload.data,
        RefundPolicyCount: action.RefundPolicyCount,
      };
    case "GET_CANCELLATION_POLICY_FULFILLED":
      return {
        ...state,
        loading: false,
        CancellationPolicy: action.payload.data,
        CancellationPolicyCount: action.CancellationPolicyCount,
      };
    case "GET_CATEGORIES_FULFILLED":
      return {
        ...state,
        categoriesList: action.payload,
      };

    case "GET_CATEGORIES_LIST_FULFILLED":
      return {
        ...state,
        categories: action.payload,
        loading: false,
        categoriesCount: action.categoriesCount,
      };

    case "GET_VEHICAL_TYPE_FULFILLED":
      return {
        ...state,
        categories: action.payload,
        loading: false,
        VehicalsTypelists: action.payload.data,
      };
    case "GET_ALL_CATEGORIES_AND_VEHICAL_FULFILLED":
      return {
        ...state,
        categories: action.payload,
        loading: false,
        vehicleNumList: action.payload?.vehicleList,
        vehicleTypeList: action.payload?.vehicleTypeList,
        vehicleCategoriesList: action.payload?.vehicleCategoriesList,
      };

    case "GET_VEHICAL_CATEGORY_FULFILLED":
      return {
        ...state,
        categories: action.payload,
        loading: false,
        VehicalCategoryList: action.payload.data,
      };
    case "GET_VEHICAL_NUMBER_FULFILLED":
      return {
        ...state,
        categories: action.payload,
        loading: false,
        VehicalsNumberlists: action.payload.data,
      };
    case "GET_VISITOR_DETAILS_BY_PLACE_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorDetailOfPlace: action.payload.data,
      };
    case "GET_VISITOR_TYPE_BY_PLACE_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorTypeofPlace: action.payload.data,
      };
    case "GET_VISITOR_SUB_TYPE_BY_TYPE_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorSubTypeListByType: action.payload.data,
      };
    case "ADD_VISITOR_SUB_TYPE_BY_TYPE_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorSubTypeListByType: action.payload?.touristSubTypeList,
      };
    case "GET_VISITOR_SUB_SUB_TYPE_BY_TYPE_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorSubSubTypeListBySubType: action.payload.data,
      };
    case "ADD_VISITOR_SUB_SUB_TYPE_BY_TYPE_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorSubSubTypeListBySubType: action.payload?.touristSubSubTypeList,
      };
    case "GET_SUBCATEGORIES_FULFILLED":
      return {
        ...state,
        subCategories: action.payload,
        loading: false,
        subCategoryCount: action.subCategoryCount,
      };
    case "GET_SUBCATEGORIES_LIST_FULFILLED":
      return {
        ...state,
        subCategoriesList: action.payload,
      };
    case "GET_SUBSUBCATEGORIES_FULFILLED":
      return {
        ...state,
        subSubCategories: action.payload,
        loading: false,
        subSubCategoryCount: action.subSubCategoryCount,
      };
    case "GET_OFFERLIST_FULFILLED":
      return {
        ...state,
        loading: false,
        offerlists: action.payload,
        offerCount: action.offerCount,

      };
    case "GET_ZONE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        Zonelists: action.payload.data,

      }
    case "GET_ZONE_LIST_BY_PLACE_FULFILLED":
      return {
        ...state,
        loading: false,
        PlaceZonelists: action.payload.data,

      }
    case "GET_ALL_BY_PLACE_FULFILLED":
      console.log('GET_ALL_BY_PLACE_FULFILLED>>',action.payload);
      return {
        ...state,
        loading: false,
        zoneList:action.payload?.zoneList,
        subZoneList:action.payload?.subZoneList,
        subSubZoneList:action.payload?.subSubZoneList,

      }
    case "GET_SUB_ZONE_LIST_BY_ZONE_FULFILLED":
      return {
        ...state,
        loading: false,
        SubZonelists: action.payload.data,
      }
    case "ADD_SUB_ZONE_LIST_BY_ZONE_FULFILLED":
      return {
        ...state,
        loading: false,
        SubZonelists: action.payload?.subZoneList,
      }
    case "GET_SUB_SUB_ZONE_LIST_BY_ZONE_FULFILLED":
      return {
        ...state,
        loading: false,
        SubSubZonelists: action.payload.data,
      }
    case "GET_BANNERLIST_FULFILLED":
      return {
        ...state,
        loading: false,
        bannerlists: action.payload,
        bannerCount: action.bannerCount,

      };
    case "GET_ORGANIZATIONVIDEO_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        organizationVideoLists: action.payload,
        organizationVideoCount: action.organizationVideoCount,

      };

    case "GET_ORGANIZATION_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        organizationLists: action.payload,
        organizationCount: action.organizationCount,

      };

    case "GET_PLACE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        PlaceLists: action.payload,
        placeCount: action.placeCount,

      };
    case "GET_PRICE_PLACE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        PricePlaceLists: action.payload,

      };

    case "GET_ALL_TICKET_TYPE_FULFILLED":
      const type = action.payload.data;
      return {
        ...state,
        loading: false,
        placeTicketTypes: type.ticketTypeLists,
        // TicketSubTypeList: type.ticketSubTypeList,
        placeSubTicketTypes: type.ticketSubTypeList,
        placeSubSubTicketTypes: type.ticketSubsubTypeLists,
      };
    case "GET_TICKET_TYPE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        TicketTypeList: action.payload.TicketTypeLists,

      };
    case "GET_TICKET_SUB_TYPE_LIST_FULFILLED":
      console.log('GET_TICKET_SUB_TYPE_LIST_FULFILLED>>',action.payload)
      return {
        ...state,
        loading: false,
        TicketSubTypeList: action.payload.TicketSubTypeLists,

      };
    case "GET_TICKET_SUB_SUB_TYPE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        TicketSubSubTypeList: action.payload.TicketSubsubTypeLists,

      };

    case "GET_TOURIST_TYPE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        TouristTypeList: action.payload.data,

      }
    case "GET_TICKET_PRICE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        TicketPriceList: action.payload.TicketPriceLists,
      };

    case "GET_CITY_FULFILLED":
      return {
        ...state,
        cities: action.payload,
        loading: false,
        citiesCount: action.citiesCount,
      };
    case "GET_LOCATIONS_FULFILLED":
      return {
        ...state,
        locations: action.payload,
        loading: false,
        locationsCount: action.locationsCount,
      };
    case "GET_DESTINATION_FULFILLED":
      return {
        ...state,
        destination: action.payload,
        loading: false,
        destinationCount: action.destinationCount,

      };

    case "GET_STATE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        stateLists: action.payload
      };
    case "GET_GALLERY_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        GalleryLists: action.payload,
        galleryCount: action.galleryCount,

      };
    case "GET_HOME_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        HomeLists: action.payload,
        HomeCount: action.HomeCount,

      };
    case "GET_ALL_PLACE_FULFILLED":
      return {
        ...state,
        loading: false,
        places: action.payload,

      };
    case "GET_MERCHANT_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        MerchantLists: action.payload,
        merchantCount: action.merchantCount,

      };
    case "GET_ALL_MERCHANTS_FULFILLED":
      return {
        ...state,
        loading: false,
        merchants: action.payload,

      };
    case "GET_MERCHANT_PORTFOLIO_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        MerchantPortfolioLists: action.payload,
        merchantPortfolioCount: action.merchantPortfolioCount,

      };
    case "GET_BLOG_CATEGORY_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        BlogCategoryList: action.payload,
        blogCategoryCount: action.blogCategoryCount,

      };
    case "GET_ALL_BLOG_CATEGORY_FULFILLED":
      return {
        ...state,
        loading: false,
        blogCategories: action.payload,
      };
    case "GET_BLOG_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        BlogList: action.payload,
        blogCount: action.blogCount,

      };
    case "GET_PARTNER_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        PartnerLists: action.payload,
        partnerCount: action.partnerCount,
        statusCounts: action.statusCounts,
      };
    case "GET_GOVERNMENT_PARTNER_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        PartnerLists: action.payload,
        partnerCount: action.partnerCount,

      };
    case "GET_ONLINEbOOKING_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        OnlineBookingists: action.payload,
        OnlineBookingistCount: action.OnlineBookingistCount,

      };
    case "GET_TOURCATEGORY_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        TourCategorys: action.payload,
        TourCategoryCount: action.TourCategoryCount,

      };
    case "GET_TOUR_GUIDE_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        TourGuideList: action.payload,
        TourGuideListCount: action.TourGuideListCount,

      };

    case "GET_BOOKING_FORM_DATA_FULFILLED":
      return {
        ...state,
        loading: false,
        ticketBookingForms: action.payload?.ticketBookingForms || [],
        ticketBookingFormsCount: action.payload?.ticketBookingFormsCount || 0,
      };

    case "EDIT_BOOKING_FORM_FULFILLED":
      return {
        ...state,
        loading: false,
        editBookingForm: action.payload?.bookingForm,
        // editableForms: action.payload?.editableForms,
      };
    case "EDIT_BOOKING_FORM_RESET":
      return {
        ...state,
        loading: false,
        editBookingForm:[],
        TicketTypeList:[],
        TicketSubTypeList:[],
        placeTicketTypes:[],
        placeSubTicketTypes:[],
        placeSubSubTicketTypes:[],
        TicketSubSubTypeList:[],
        ticketFormAdditionalFields:[],
        PlaceZonelists:[],
        SubZonelists:[],
        zoneList:[],
        subZoneList:[],
        subSubZoneList:[],
        VehicalCategoryList:[],
        VehicalsTypelists:[],
        VehicalsNumberlists:[],
        vehicleTypeList:[],
        vehicleCategoriesList:[],
        vehicleNumList:[],
        visitorTypeofPlace:[],
        visitorSubTypeListByType:[],
        visitorSubSubTypeListBySubType:[],
        visitorCategories:[],
        visitorCatList:[],
        visitorSubCatList:[],
        visitorSubSubCatList:[],
        editVisitorDetails:[],
        bookingCategoriesList:[],
        bookingSubCategoriesList:[],
        bookingTimingForm:[],
        bookingTimings:[],
        ticketBasePrice:[],
        servicesPrice:[],
        ticketPrices:[],
        priceFormDetails:[],
        TouristTypeList:[],
        ticketsPerDay:[],
        SubSubZonelists:[],
       };

    case "GET_ADDITIONAL_FIELDS_FULFILLED":
      var data = action.payload.additionalFields;
      return {
        ...state,
        loading: false,
        additionalFieldsList: data.filter(item => item.type === 'additionalField'),
        bookingCategoriesList: data.filter(item => item.type === 'groupBooking'),
      };

    case "GET_SUB_ADDITIONAL_FIELDS_FULFILLED":
      var data = action.payload.subAdditionalFields;
      return {
        ...state,
        loading: false,
        subAdditionalFieldsList: data.filter(item => item.type === 'additionalField'),
        bookingSubCategoriesList: data.filter(item => item.type === 'groupBooking'),
      };

    case "GET_SUB_SUB_ADDITIONAL_FIELDS_FULFILLED":
      var data = action.payload.subSubAdditionalFields;
      return {
        ...state,
        loading: false,
        subSubAdditionalFieldsList: data.filter(item => item.type === 'additionalField'),
        bookingSubSubCategoriesList: data.filter(item => item.type === 'groupBooking'),
      };

    case "GET_EVENT_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        EventLists: action.payload,
        eventCount: action.eventCount,

      };
    case "GET_CHECKTHISOUT_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        CheckThisOutLists: action.payload,
        checkThisOutCount: action.checkThisOutCount,

      };
    case "GET_SCHEME_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        SchemeLists: action.payload,
        schemeCount: action.schemeCount,

      };
    case "GET_SUBSCRIBER_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        SubscriberLists: action.payload,
        SubscriberCount: action.schemeCount,

      };
    case "GET_REVIEW_CATEGORY_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        questionReviewCategories: action.payload,
      };
    case "GET_SEO_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        SeoLists: action.payload,
        SeoCount: action.SeoCount,

      };
    case "GET_STATELIST_FULFILLED":
      return {
        ...state,
        loading: false,
        States: action.payload,
        StateCount: action.StateCount,

      };
    case "GET_BOOKING_LIST_FULFILLED":
      return {
        ...state,
        loading: false,
        BookingLists: action.payload,
        bookingCount: action.bookingCount,

      };
    case "GET_VISITOR_CATEGORY_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorCategories: action.payload.visitorCategories,
      };
    case "GET_ALL_VISITOR_CATEGORIES_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorCatList: action.payload?.visitorCatList,
        visitorSubCatList: action.payload?.visitorSubCatList,
        visitorSubSubCatList: action.payload?.visitorSubSubCatList,
      };
    case "GET_VISITOR_DETAILS_FULFILLED":
          return {
            ...state,
            loading: false,
            editVisitorDetails: action.payload?.visitorDetails
          };
    case "GET_VISITOR_SUB_CATEGORY_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorSubCategories: action.payload.visitorSubCategories,
      };
    case "GET_VISITOR_SUB_SUB_CATEGORY_FULFILLED":
      return {
        ...state,
        loading: false,
        visitorSubSubCategories: action.payload.visitorSubSubCategories,
      };
    case "GET_BOOKING_CATEGORIES_FULFILLED":
      return {
        ...state,
        loading: false,
        bookingCategories: action.payload?.categories,
      };
    case "GET_BOOKING_SUB_CATEGORIES_FULFILLED":
      return {
        ...state,
        loading: false,
        bookingSubCategories: action.payload?.subCategories,
      };
    case "GET_BOOKING_SUB_SUB_CATEGORIES_FULFILLED":
      return {
        ...state,
        loading: false,
        bookingSubSubCategories: action.payload?.subSubCategories,
      };
    case "GET_ADDITIONAL_CATEGORIES_FULFILLED":
      return {
        ...state,
        loading: false,
        additionalCategories: action.payload?.categories,
      };
    case "GET_ADDITIONAL_SUB_CATEGORIES_FULFILLED":
      return {
        ...state,
        loading: false,
        additionalSubCategories: action.payload?.subCategories,
      };
    case "GET_ADDITIONAL_SUB_SUB_CATEGORIES_FULFILLED":
      return {
        ...state,
        loading: false,
        additionalSubSubCategories: action.payload?.subSubCategories,
      };
    case "GET_BOOKING_TIMING_FORM_FULFILLED":
      return {
        ...state,
        loading: false,
        bookingTimingForm: action.payload?.data,
        bookingTimings: action.payload?.timings,
      };
    case "GET_TICKET_INFO_FULFILLED":
      return {
        ...state,
        loading: false,
        ticketInfo: action.payload?.data,
        ticketFormAdditionalFields: action.payload.data?.ticketFormAdditionalFields ?? [],
      };
    case "EDIT_ADDITIONAL_FORM_DETAILS":
      return {
        ...state,
        loading: false,
        additionalFieldDetails: action.payload,
      };
    case "DELETE_MULTIPLE_TIMING_FULFILLED":
      return {
        ...state,
        loading: false,
        bookingTimingForm: action.payload?.formData,
        bookingTimings: action.payload?.timings,
      };
    case "GET_TICKET_PRICE_DETAILS_FULFILLED":
      const ticketPriceDetails = action?.payload?.ticketPriceDetails;
      return {
        ...state,
        loading: false,
        ticketBasePrice:ticketPriceDetails?.basePrice ?? {},
        servicesPrice: ticketPriceDetails?.services ?? [],
        ticketPrices: ticketPriceDetails?.ticketPrices ?? [],
        priceFormDetails: ticketPriceDetails?.priceFormDetails ?? [],
      };
      case "GET_TICKETS_PER_DAY_FULFILLED":
        return {
          ...state,
          loading: false,
          ticketsPerDay:action.payload?.ticketsPerday,
      };
      case "RESET_VISITOR_SUB_SUB_TYPE":
      return {
        ...state,
        visitorSubTypeListByType: [],
        visitorSubSubTypeListBySubType: [],
      };
    case "GET_ROLES_FAILED":
    case "GET_CATEGORIES_FAILED":
    case "GET_CATEGORIES_LIST_FAILED":
    case "GET_SUBCATEGORIES_FAILED":
    case "GET_SUBCATEGORIES_LIST_FAILED":
    case "GET_SUBSUBCATEGORIES_FAILED":
    case "GET_ORGANIZATIONVIDEO_LIST_FAILED":
    case "GET_ORGANIZATION_LIST_FAILED":
    case "GET_OFFERLIST_FAILED":
    case "GET_BANNERLIST_FAILED":
    case "GET_PLACE_LIST_FAILED":
    case "GET_STATE_LIST_FAILED":
    case "GET_GALLERY_LIST_FAILED":
    case "GET_HOME_LIST_FAILED":
    case "GET_ALL_PLACE_FAILED":
    case "GET_PRICE_PLACE_LIST_FAILED":
    case "GET_TICKET_TYPE_LIST_FAILED":
    case "GET_MERCHANT_LIST_FAILED":
    case "GET_ALL_MERCHANTS_FAILED":
    case "GET_MERCHANT_PORTFOLIO_LIST_FAILED":
    case "GET_BLOG_CATEGORY_LIST_FAILED":
    case "GET_ALL_BLOG_CATEGORY_FAILED":
    case "GET_BLOG_LIST_FAILED":
    case "GET_PARTNER_LIST_FAILED":
    case "GET_GOVERNMENT_PARTNER_LIST_FAILED":
    case "GET_EVENT_LIST_FAILED":
    case "GET_CHECKTHISOUT_LIST_FAILED":
    case "GET_SCHEME_LIST_FAILED":
    case "GET_SUBSCRIBER_LIST_FAILED":
    case "GET_STATELIST_FAILED":
    case "GET_BOOKING_LIST_FAILED":
    case "GET_CITY_FAILED":
    case "GET_ZONE_LIST_FAILED":
    case "GET_ZONE_LIST_BY_PLACE_FAILED":
    case "GET_ALL_BY_PLACE_FAILED":
    case "GET_LOCATIONS_FAILED":
    case "GET_TOUR_GUIDE_LIST_FAILED":
    case "GET_TOURIST_TYPE_LIST_FAILED":
    case "GET_TICKET_PRICE_LIST_FAILED":
    case "GET_TICKET_SUB_TYPE_LIST_FAILED":
    case "GET_TICKET_SUB_SUB_TYPE_LIST_FAILED":
    case "GET_SUB_ZONE_LIST_BY_ZONE_FAILED":
    case "GET_ADDITIONAL_FIELDS_FAILED":
    case "GET_SUB_ADDITIONAL_FIELDS_FAILED":
    case "GET_SUB_SUB_ADDITIONAL_FIELDS_FAILED":
    case "GET_VEHICAL_CATEGORY_FAILED":
    case "GET_VEHICAL_TYPE_FAILED":
    case "GET_ALL_CATEGORIES_AND_VEHICAL_FAILED":
    case "GET_VEHICAL_NUMBER_FAILED":
    case "GET_VISITOR_CATEGORY_FAILED":
    case "GET_ALL_VISITOR_CATEGORIES_FAILED":
    case "GET_VISITOR_DETAILS_FAILED":
    case "GET_VISITOR_SUB_CATEGORY_FAILED":
    case "GET_VISITOR_SUB_SUB_CATEGORY_FAILED":
    case "GET_SUB_SUB_ZONE_LIST_BY_ZONE_FAILED":
    case "GET_VISITOR_DETAILS_BY_PLACE_FAILED":
    case "GET_VISITOR_SUB_SUB_TYPE_BY_TYPE_FAILED":
    case "GET_VISITOR_SUB_TYPE_BY_TYPE_FAILED":
    case "GET_BOOKING_CATEGORIES_FAILED":
    case "GET_ADDITIONAL_CATEGORIES_FAILED":
    case "GET_BOOKING_TIMING_FORM_FAILED":
    case "GET_TICKET_INFO_FAILED":
    case "GET_DESTINATION_FAILED":
    case "GET_ALL_TICKET_TYPE_FAILED":
    case "DELETE_MULTIPLE_TIMING_FAILED":
    case "GET_TICKET_PRICE_DETAILS_FAILED":
    case "GET_TICKETS_PER_DAY_FAILED":
      toast.error(action.payload?.message);
      return { ...state, loading: false, errors: action.payload };
    default:
      return state;
  }
};

export default indexReducer;
